//https://github.com/enRose/enRose.github.io/blob/master/React/redux-saga-error-handling.md
//https://yiniski.medium.com/redux-saga-error-handling-7f1dafa4be37

import { createStore, applyMiddleware, compose, Store } from 'redux';
import createSagaMiddleware, { SagaMiddleware } from 'redux-saga';
import { thunk } from 'redux-thunk';

import isDevelopment from '../utils/development';
import reactotron from '../config/ReactotronConfig';
import rootReducer from './modules/root-reducer';
import rootSaga from './modules/root-saga';

import { ISA_ERROR } from './../constants/index';
// import notification from '../services/notification';
// import history from '../services/history';
// import normalizeError from '../utils/normalize-error';
// import * as authActions from './modules/auth/auth-actions';

const sagaMiddleware: SagaMiddleware = isDevelopment()
  ? createSagaMiddleware({ sagaMonitor: reactotron.createSagaMonitor!() })
  : createSagaMiddleware();

const middlewares = [thunk, sagaMiddleware];

const enchancer = isDevelopment()
  ? compose(reactotron.createEnhancer!(), applyMiddleware(...middlewares))
  : applyMiddleware(...middlewares);

const store = createStore(rootReducer, enchancer);

sagaMiddleware
  .run(rootSaga)
  .toPromise()
  .catch((error: any) => {
    console.log({
      message: error.message,
      source: 'sagaError',
      stacktrace: error.sagaStack,
      response: error.response
    });
    store.dispatch({
      type: ISA_ERROR,
      error: {
        message: error.message,
        response: error.response
      }
    });

    // if (error?.response?.status === 401) {
    //   history.push('/auth/login');

    //   store.dispatch(authActions.logoutRequest());

    //   notification.warning('Login expirado!');
    // } else {
    //   const message = normalizeError(error);
    //   notification.error(message);
    // }
  });

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
